import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { realtime } from "@/lib/realtime";

// Connects to the shared real-time WebSocket while logged in and surfaces
// live notifications / order events as toasts across the whole app.
export function RealtimeListener() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) { realtime.disconnect(); return; }
    realtime.connect();

    const offNotif = realtime.on("notification", (m) => {
      const n = m.notification || {};
      toast(n.title || "New notification", { description: n.message });
    });
    const offOrder = realtime.on("order", (m) => {
      if (m.event === "new_sale") toast.success("New sale! 🎉", { description: `${m.item_title} · $${m.amount}` });
      else if (m.event === "purchase_confirmed") toast.success("Order confirmed", { description: m.item_title });
    });

    return () => { offNotif(); offOrder(); };
  }, [user]);

  return null;
}
